if ('undefined' !== typeof authUser && (3 !== authUser.rol_id || ('undefined' !== typeof isImpersonating && isImpersonating))) {
    require('./suplantacion');
}

require('./autenticacion');

